import { UserManager } from 'oidc-client'

// 使用id4更改这里1
class ApplicationUserManager extends UserManager {
  constructor () {
    super({
      authority: 'https://sumengzhengba.top:5005',
      client_id: 'blogadminjs',
      redirect_uri: 'https://dy.sumengzhengba.top/callback',
      response_type: 'id_token token',
      scope: 'openid profile roles blog.core.api',
      post_logout_redirect_uri: 'https://dy.sumengzhengba.top'

      // authority: 'http://175.27.221.41:5004',
      // client_id: 'blogadminjs',
      // redirect_uri: 'http://175.27.221.41:70/callback',
      // response_type: 'id_token token',
      // scope: 'openid profile roles blog.core.api',
      // post_logout_redirect_uri: 'http://175.27.221.41:70'
    })
  }

  async login () {
    await this.signinRedirect()
    return this.getUser()
  }

  async logout () {
    return this.signoutRedirect()
  }
}

const applicationUserManager = new ApplicationUserManager()
export { applicationUserManager as default }
